(() => {
  if (window.CFAvailability) return;
  const configNode = document.querySelector('[data-cf-availability-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = (key, values = {}) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll(`[${name}]`, String(replacement)), config.strings[key] || key);
  const createArrow = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [name, value] of Object.entries({ class: 'cf-text-arrow', 'aria-hidden': 'true', focusable: 'false', width: '1em', height: '1em', viewBox: '0 0 16 16', fill: 'none' })) svg.setAttribute(name, value);
    svg.style.cssText = 'display:inline-block;vertical-align:-.1em;flex-shrink:0';
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    for (const [name, value] of Object.entries({ d: 'M3 13 13 3M3 3h10v10', stroke: 'currentColor', 'stroke-width': '1.4', 'stroke-linecap': 'square', 'stroke-linejoin': 'miter' })) path.setAttribute(name, value);
    svg.append(path);
    return svg;
  };
  const jsonResponse = async (response) => {
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || text('retry'));
    return data;
  };
  const rootPath = window.Shopify?.routes?.root || '/';
  const cartChange = (key, quantity, properties) => fetch(`${rootPath}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, properties }) }).then(jsonResponse);
  const publicProperties = (original, state, making, dispatch, mixedMessage) => {
    const properties = { ...original, _cf_fulfillment: state, Fulfillment: text(state) };
    delete properties.Dispatch;
    delete properties.Production;
    delete properties['Order dispatch'];
    if (state === 'made') properties.Production = `${making} · ${text('plus_transit')}`;
    else properties.Dispatch = dispatch;
    if (mixedMessage) properties['Order dispatch'] = mixedMessage;
    return properties;
  };

  class AvailabilityBrowse extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.pool = this.querySelector('[data-cf-product-pool]') || this.querySelector('#product-grid');
      if (!this.pool) return;
      this.pageSize = Number(this.dataset.cfPageSize) || 24;
      this.limit = this.pageSize;
      this.mode = location.hash === '#ready-to-ship' ? 'ready' : location.hash === '#made-to-order' ? 'made' : 'all';
      this.size = 'all';
      this.category = 'all';
      this.collect();
      this.addEventListener('click', (event) => {
        const filter = event.target.closest('[data-cf-filter]');
        if (filter) {
          event.preventDefault();
          this.mode = filter.dataset.cfFilter;
          this.limit = this.pageSize;
          history.replaceState(null, '', `${location.pathname}${location.search}${filter.getAttribute('href')}`);
          this.apply();
        }
        if (event.target.closest('[data-cf-load-more]')) { this.limit += this.pageSize; this.apply(); }
        if (event.target.closest('[data-cf-reset]')) {
          this.mode = 'all'; this.category = 'all'; this.size = 'all'; this.limit = this.pageSize;
          this.querySelectorAll('select').forEach(select => { select.value = 'all'; });
          history.replaceState(null, '', `${location.pathname}${location.search}#all-pieces`);
          this.apply();
        }
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-cf-size]')) this.size = event.target.value;
        if (event.target.matches('[data-cf-category]')) { this.category = event.target.value; this.size = 'all'; }
        this.limit = this.pageSize; this.apply();
      });
      this.hashListener = () => { this.mode = location.hash === '#ready-to-ship' ? 'ready' : location.hash === '#made-to-order' ? 'made' : 'all'; this.limit = this.pageSize; this.apply(); };
      window.addEventListener('hashchange', this.hashListener);
      this.apply();
      if (this.dataset.cfNextPage) this.loadRemaining();
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.hashListener); }
    collect() {
      this.cards = [...this.pool.querySelectorAll('[data-cf-card]')];
      this.cards.forEach(card => {
        const data = card.querySelector('[data-cf-card-variants]');
        card.cfVariants = data ? JSON.parse(data.textContent) : [];
      });
    }
    categoryFor(card) {
      const kind = (card.dataset.cfKind || '').toLowerCase();
      if (/ear|cuff/.test(kind)) return 'ear';
      return ['bracelet', 'necklace', 'ring'].find(category => kind.includes(category)) || 'other';
    }
    matchesCategory(card) { return this.category === 'all' || this.categoryFor(card) === this.category; }
    sizeKey(value, card) {
      const size = String(value || '').trim().replace(/\s+/g, ' ').replace(/\s*(cm|mm)\b/gi, '$1');
      if (this.categoryFor(card) === 'ring') {
        if (/^(s|small)(?:$|[\s(])/i.test(size)) return 'S';
        if (/^(m|medium)(?:$|[\s(])/i.test(size)) return 'M';
        if (/^(l|large)(?:$|[\s(])/i.test(size)) return 'L';
        if (/^(c|custom)(?:$|[\s(])/i.test(size)) return 'C';
      }
      return size;
    }
    matchesSize(variant, card) { return this.size === 'all' || this.sizeKey(variant.size, card) === this.size; }
    eligibleVariants(card) { return card.cfVariants.filter(variant => this.mode === 'all' ? variant.state === 'ready' || variant.state === 'made' : variant.state === this.mode); }
    updateSizeOptions() {
      const select = this.querySelector('[data-cf-size]');
      if (!select) return;
      const values = new Set();
      this.cards.filter(card => this.matchesCategory(card)).forEach(card => this.eligibleVariants(card).forEach(variant => {
        const value = this.sizeKey(variant.size, card);
        if (value && value !== '__one_size__') values.add(value);
      }));
      if (!values.has(this.size)) this.size = 'all';
      const order = ['S', 'M', 'L', 'C'];
      const sorted = [...values].sort((a, b) => {
        if (order.includes(a) || order.includes(b)) return (order.includes(a) ? order.indexOf(a) : order.length) - (order.includes(b) ? order.indexOf(b) : order.length) || a.localeCompare(b, undefined, { numeric: true });
        return a.localeCompare(b, undefined, { numeric: true });
      });
      const sizes = this.category === 'ring' ? [...order, ...sorted.filter(value => !order.includes(value))] : sorted;
      const options = sizes.map(value => ({ value, label: this.category === 'ring' && order.includes(value) ? text(`ring_size_${value.toLowerCase()}`) : value.replace(/(\d)(cm|mm)\b/gi, '$1 $2'), disabled: !values.has(value) }));
      const signature = JSON.stringify(options);
      if (this.sizeOptionsSignature !== signature) {
        [...select.options].slice(1).forEach(option => option.remove());
        options.forEach(({ value, label, disabled }) => { const option = document.createElement('option'); option.value = value; option.textContent = label; option.disabled = disabled; select.append(option); });
        this.sizeOptionsSignature = signature;
      }
      select.value = this.size;
    }
    apply() {
      this.dataset.cfMode = this.mode;
      this.updateSizeOptions();
      const pages = this.querySelector('[data-cf-search-pages]'); if (pages) pages.hidden = this.mode !== 'all';
      const matches = this.cards.filter(card => {
        const availability = this.mode === 'all' || Boolean(this.mode === 'ready' ? card.dataset.cfReadyId : card.dataset.cfMadeId);
        return availability && this.matchesCategory(card) && (this.size === 'all' || this.eligibleVariants(card).some(variant => this.matchesSize(variant, card)));
      });
      matches.sort((a, b) => this.mode === 'all' && this.dataset.cfPreserveOrder !== 'true' ? Number(Boolean(b.dataset.cfReadyId)) - Number(Boolean(a.dataset.cfReadyId)) || Number(Boolean(b.dataset.cfMadeId)) - Number(Boolean(a.dataset.cfMadeId)) || Number(a.dataset.cfIndex) - Number(b.dataset.cfIndex) : Number(a.dataset.cfIndex) - Number(b.dataset.cfIndex));
      this.cards.forEach(card => { card.hidden = true; });
      matches.forEach((card, index) => {
        this.pool.append(card); card.hidden = index >= this.limit;
        if (card.dataset.cfInquiry === 'true') return;
        const hasMatchingReady = card.cfVariants.some(v => v.state === 'ready' && this.matchesSize(v, card));
        const desired = this.mode === 'made' ? 'made' : hasMatchingReady ? 'ready' : 'made';
        const record = card.cfVariants.find(v => v.state === desired && this.matchesSize(v, card));
        const id = record?.id || (desired === 'ready' ? card.dataset.cfReadyId : card.dataset.cfMadeId);
        card.querySelectorAll('[data-cf-card-link]').forEach(link => { link.href = id ? `${card.dataset.cfUrl}?variant=${id}` : card.dataset.cfUrl; });
        const image = record?.image || (desired === 'ready' ? card.dataset.cfReadyImage : card.dataset.cfMadeImage);
        const imageNode = card.querySelector('.cf-browse-card__image');
        if (imageNode && image && imageNode.getAttribute('src') !== image) { imageNode.src = image; imageNode.removeAttribute('srcset'); }
        const price = card.querySelector('[data-cf-card-price]');
        if (price && id) price.textContent = record?.price || (desired === 'ready' ? card.dataset.cfReadyPrice : card.dataset.cfMadePrice);
        const badge = card.querySelector('[data-cf-card-badge]');
        if (badge) { badge.hidden = Boolean(id && desired === 'ready'); badge.textContent = `( ${text(id ? desired : 'unavailable')} )`; }
      });
      this.querySelectorAll('[data-cf-filter]').forEach(link => { if (link.dataset.cfFilter === this.mode) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
      const caption = this.querySelector('[data-cf-browse-caption]');
      if (caption) {
        const copy = caption.dataset[{ all: 'cfAllIntro', ready: 'cfReadyIntro', made: 'cfMadeIntro' }[this.mode]] ?? text(`${this.mode}_intro`);
        caption.textContent = copy; caption.hidden = caption.dataset.cfShowIntro === 'false' || !copy.trim();
      }
      const count = this.querySelector('[data-cf-browse-count]');
      if (count) {
        const copy = count.dataset.cfCountText ?? text('piece_count', { count: matches.length });
        count.textContent = copy.replaceAll('[count]', String(matches.length)); count.hidden = count.dataset.cfShowCount === 'false' || !copy.trim();
      }
      const empty = this.querySelector('[data-cf-browse-empty]'); if (empty) empty.hidden = matches.length > 0;
      const more = this.querySelector('[data-cf-load-more]'); if (more) more.hidden = matches.length <= this.limit;
    }
    async loadRemaining() {
      try {
        let next = this.dataset.cfNextPage;
        const seen = new Set(this.cards.map(card => card.dataset.cfProductId));
        while (next) {
          const url = new URL(next, location.origin); url.searchParams.set('section_id', this.dataset.cfSection);
          const response = await fetch(url); if (!response.ok) throw new Error(text('retry'));
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = html.querySelector('cf-availability-browse'); if (!source) break;
          source.querySelectorAll('[data-cf-card]').forEach(card => { if (!seen.has(card.dataset.cfProductId)) { seen.add(card.dataset.cfProductId); card.dataset.cfIndex = String(this.cards.length + seen.size); this.pool.append(document.importNode(card, true)); } });
          next = source.dataset.cfNextPage;
        }
        this.dataset.cfNextPage = ''; this.collect(); this.apply();
      } catch { const count = this.querySelector('[data-cf-browse-count]'); if (count) count.textContent += ` · ${text('retry')}`; }
    }
  }

  class ProductAvailability extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-cf-product-data]').textContent);
      this.form = document.getElementById(this.dataset.cfForm);
      this.section = this.closest('[id^="MainProduct-"]') || this.closest('section');
      this.selected = this.data.selected;
      this.pending = false;
      this.addEventListener('click', event => {
        const path = event.target.closest('[data-cf-path]');
        if (path) { const variant = this.data.variants.find(v => v.state === path.dataset.cfPath); if (variant) this.select(variant); }
        if (event.target.closest('[data-cf-switch-stock]')) { const variant = this.data.variants.find(v => v.state === 'ready'); if (variant) this.select(variant); }
      });
      this.changeListener = event => {
        if (event.target.matches('input[type=radio]') && event.target.closest('variant-radios')) {
          const choices = [...event.target.closest('variant-radios').querySelectorAll('fieldset')].map(field => field.querySelector('input:checked')?.value);
          this.invalidChoice = !this.data.variants.some(v => v.options.every((option, index) => option === choices[index]));
          if (this.invalidChoice) { this.pending = false; this.render(); }
        }
        if (event.target.matches('input[name="id"]') && event.target.form === this.form) { this.selected = Number(event.target.value); this.invalidChoice = false; this.pending = true; this.render(); }
        if (event.target.matches('.quantity__input') && event.target.form === this.form) this.syncButtons();
      };
      this.section.addEventListener('change', this.changeListener);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId !== this.dataset.cfSection) return;
        const source = event.data.html.querySelector(`[data-cf-form="${this.dataset.cfForm}"] [data-cf-product-data]`);
        if (source) this.data = JSON.parse(source.textContent);
        this.selected = event.data.variant.id; this.pending = false; queueMicrotask(() => this.render());
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => { this.refresh().catch(() => {}); });
      this.bar = this.querySelector('[data-cf-purchase-bar]');
      if (this.bar) {
        document.body.classList.add('cf-has-purchase-bar');
        this.resizeObserver = new ResizeObserver(() => document.body.style.setProperty('--cf-purchase-bar-height', `${this.bar.offsetHeight}px`));
        this.resizeObserver.observe(this.bar);
      }
      this.render();
      const button = this.form?.querySelector('[name="add"]');
      if (button) { this.buttonObserver = new MutationObserver(() => this.syncBar()); this.buttonObserver.observe(button, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] }); }
    }
    disconnectedCallback() { this.unsubscribe?.(); this.cartUnsubscribe?.(); this.resizeObserver?.disconnect(); this.buttonObserver?.disconnect(); this.section?.removeEventListener('change', this.changeListener); if (!document.querySelector('cf-product-availability')) document.body.classList.remove('cf-has-purchase-bar'); }
    get variant() { const selected = this.data.variants.find(v => Number(v.id) === Number(this.selected)); return this.invalidChoice ? { ...selected, state: 'unavailable' } : selected; }
    select(variant) {
      const picker = this.section.querySelector('variant-radios, variant-selects');
      if (!picker) return;
      const fields = [...picker.querySelectorAll('fieldset')];
      if (fields.length) fields.forEach((field, index) => { const input = [...field.querySelectorAll('input[type="radio"]')].find(input => input.value === variant.options[index]); if (input) input.checked = true; });
      else [...picker.querySelectorAll('select')].forEach((select, index) => { select.value = variant.options[index]; });
      picker.dispatchEvent(new Event('change', { bubbles: true }));
    }
    set(node, value) { const element = this.querySelector(node); if (element) element.textContent = value; }
    render() {
      const variant = this.variant; if (!variant) return;
      this.section.querySelectorAll('.product__description p').forEach(paragraph => {
        if (/please\s+allow\s+\d+\s*[-–]\s*\d+\s+weeks/i.test(paragraph.textContent)) { paragraph.hidden = true; paragraph.dataset.cfDescriptionTiming = ''; }
      });
      this.querySelectorAll('[data-cf-path]').forEach(button => { button.disabled = !this.data.variants.some(v => v.state === button.dataset.cfPath); button.setAttribute('aria-pressed', String(button.dataset.cfPath === variant.state)); });
      const option = this.data.defaultVariant ? '' : variant.title + (/\bring\b/i.test(this.data.title) && variant.title.trim().toUpperCase() === 'S' ? ' | US 6 | EU 52' : variant.usSize ? ` | ${variant.usSize}` : '');
      this.set('[data-cf-value]', variant.state === 'ready' ? variant.unique ? text('unique_piece') : text(this.dataset.cfWoven === 'true' ? 'already_woven' : 'completed_piece') : variant.state === 'made' ? text('crafted_for_order') : text('unavailable_value'));
      const detail = variant.state === 'made' ? this.dataset.cfStrands ? text('strand_story', { count: this.dataset.cfStrands }) : text('hand_story') : variant.state === 'unavailable' ? text('unavailable_help') : '';
      this.set('[data-cf-detail]', detail);
      const detailNode = this.querySelector('[data-cf-detail]'); if (detailNode) detailNode.hidden = !detail;
      this.renderDelivery(variant);
      const nudge = this.querySelector('[data-cf-stock-nudge]'); const ready = this.data.variants.find(v => v.state === 'ready');
      if (nudge) {
        nudge.hidden = variant.state === 'ready' || !ready;
        nudge.replaceChildren();
        if (!nudge.hidden) { nudge.append(document.createTextNode(text('available_size', { size: ready.title }) + ' ')); const button = document.createElement('button'); button.type = 'button'; button.dataset.cfSwitchStock = ''; button.append(document.createTextNode(text('view_piece') + ' '), createArrow()); nudge.append(button); }
      }
      this.set('[data-cf-bar-price]', variant.price);
      this.set('[data-cf-bar-status]', `${text(variant.state)}${option ? ` · ${option}` : ''}`);
      this.form?.querySelectorAll('[data-cf-property-state]').forEach(input => { input.value = variant.state; });
      this.form?.querySelectorAll('[data-cf-property-fulfillment]').forEach(input => { input.value = text(variant.state); });
      this.form?.querySelectorAll('[data-cf-property-timing]').forEach(input => { input.name = variant.state === 'made' ? 'properties[Production]' : 'properties[Dispatch]'; input.value = variant.state === 'made' ? `${variant.making} · ${text('plus_transit')}` : variant.dispatch; });
      const picker = this.section.querySelector('variant-radios');
      if (picker) [...picker.querySelectorAll('fieldset')].forEach((field, index) => {
        field.querySelectorAll('input[type="radio"]').forEach(input => {
          const matching = this.data.variants.find(v => v.options.every((value, optionIndex) => optionIndex === index ? value === input.value : value === variant.options[optionIndex]));
          const label = input.labels?.[0]; if (!label) return;
          let note = label.querySelector('.cf-variant-status'); if (!note) { note = document.createElement('small'); note.className = 'cf-variant-status'; label.append(note); }
          const ringSizes = { S: 'US 6 | EU 52 | JP 12', M: 'US 7 | EU 54 | JP 14', L: 'US 9 | EU 60 | JP 20' };
          note.textContent = (/\bring\b/i.test(this.data.title) ? ringSizes[input.value.trim().toUpperCase()] : '') || matching?.usSize || '';
          if ([8192718209238, 8192722698454, 8192720371926, 8192721682646].includes(Number(this.data.id))) {
            const value = input.value.replace(/\s/g, '').toLowerCase();
            const medium = ['16cm', '17.5cm', 'm'].includes(value);
            const large = ['19cm', '20.5cm', '21cm', 'l'].includes(value);
            if (medium || large) {
              const sizeName = label.querySelector('[data-cf-size-name]');
              if (sizeName) sizeName.textContent = medium ? 'M' : 'L';
              note.textContent = medium ? '17.5cm | 6.7” - 7”' : '19.5cm | 7.7” - 7.8”';
            }
          }
          note.hidden = !note.textContent;
        });
      });
      this.syncButtons();
    }
    renderDelivery(variant) {
      const block = this.section.querySelector('[data-cf-delivery]');
      if (!block) return;
      block.hidden = variant.state === 'unavailable';
      block.querySelector('[data-cf-delivery-state]').textContent = text(variant.state);
      const today = new Date();
      const shipDays = variant.state === 'made' ? 28 : 1;
      const format = days => {
        const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + days, 12);
        return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
      };
      block.querySelector('[data-cf-delivery-ship]').textContent = format(shipDays);
      block.querySelector('[data-cf-delivery-arrive]').textContent = format(shipDays + 7);
    }
    syncButtons() {
      const variant = this.variant; const button = this.form?.querySelector('[name="add"]'); if (!variant || !button) return;
      const quantity = [...this.form.elements].find(element => element.name === 'quantity');
      const remaining = variant.tracked ? Math.max(0, variant.stock - variant.cartQuantity) : Infinity;
      if (quantity) {
        if (variant.state === 'ready' && Number.isFinite(remaining)) { quantity.max = String(remaining); if (Number(quantity.value) > remaining && remaining > 0) quantity.value = String(remaining); }
        else quantity.removeAttribute('max');
      }
      const blocked = variant.state === 'unavailable' || this.pending || (variant.state === 'ready' && remaining < 1);
      if (button.disabled !== blocked) button.disabled = blocked;
      const label = button.querySelector('span'); if (label) label.textContent = this.pending ? text('checking') : variant.state === 'unavailable' ? text('unavailable') : variant.state === 'ready' && remaining < 1 ? text('already_in_bag') : text('add_to_bag');
      const notifyAvailable = config.restockEnabled && !this.invalidChoice && !this.pending && variant.state === 'unavailable';
      button.hidden = Boolean(notifyAvailable);
      this.section.querySelectorAll('[data-cf-notify-product]').forEach(notify => { notify.hidden = !notifyAvailable; });
      this.syncBar();
    }
    syncBar() {
      const button = this.form?.querySelector('[name="add"]'); const barButton = this.querySelector('[data-cf-bar-buy]'); if (!button || !barButton) return;
      barButton.hidden = button.hidden;
      barButton.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
      barButton.textContent = button.querySelector('span')?.textContent || text('add_to_bag');
    }
    async refresh() {
      const url = new URL(this.data.url, location.origin); url.searchParams.set('variant', this.selected); url.searchParams.set('section_id', 'cutfound-product-availability');
      const response = await fetch(url); if (!response.ok) throw new Error(text('retry'));
      const html = new DOMParser().parseFromString(await response.text(), 'text/html'); const source = html.querySelector('[data-cf-product-data]'); if (!source) throw new Error(text('retry'));
      this.data = JSON.parse(source.textContent); this.render(); return this.variant;
    }
  }

  const beforeAdd = async (productForm) => {
    const form = productForm.form;
    const controller = [...document.querySelectorAll('cf-product-availability')].find(element => element.form === form);
    if (!controller) return true;
    const old = controller.variant;
    const quantityInput = [...form.elements].find(element => element.name === 'quantity');
    const quantity = Number(quantityInput?.value) || 1;
    try {
      const fresh = await controller.refresh();
      if (!fresh || fresh.state === 'unavailable') { productForm.handleErrorMessage(text('stock_changed')); return false; }
      if (old.state !== fresh.state) { productForm.handleErrorMessage(text('availability_changed')); return false; }
      if (fresh.state === 'ready' && fresh.tracked && quantity + fresh.cartQuantity > fresh.stock) { productForm.handleErrorMessage(text('stock_limit', { count: Math.max(0, fresh.stock - fresh.cartQuantity) })); return false; }
      return true;
    } catch { productForm.handleErrorMessage(text('retry')); return false; }
  };

  let drawerOpener;
  const openReady = async (opener) => {
    const dialog = document.getElementById('CFReadyPieces'); if (!dialog) { location.assign(config.allUrl + '#ready-to-ship'); return; }
    drawerOpener = opener; dialog.showModal();
    const content = dialog.querySelector('[data-cf-ready-content]'); content.textContent = text('loading');
    try {
      const url = new URL(config.allUrl, location.origin); url.searchParams.set('section_id', 'cutfound-ready-pieces');
      const response = await fetch(url); if (!response.ok) throw new Error(text('retry'));
      const html = new DOMParser().parseFromString(await response.text(), 'text/html'); const pool = html.querySelector('[data-cf-ready-pool]'); if (!pool) throw new Error(text('retry'));
      const current = opener.closest('cf-product-availability'); const preferred = current?.variant?.title;
      const cards = [...pool.children]; cards.sort((a, b) => Number((b.dataset.cfReadySizes || '').split('|').includes(preferred)) - Number((a.dataset.cfReadySizes || '').split('|').includes(preferred)));
      cards.forEach(card => {
        const node = card.querySelector('[data-cf-card-variants]'); if (!node) return;
        const records = JSON.parse(node.textContent); const variant = records.find(v => v.state === 'ready' && v.size === preferred) || records.find(v => v.state === 'ready'); if (!variant) return;
        card.querySelectorAll('[data-cf-card-link]').forEach(link => { link.href = `${card.dataset.cfUrl}?variant=${variant.id}`; });
        const image = card.querySelector('.cf-browse-card__image'); if (image && variant.image) { image.src = variant.image; image.removeAttribute('srcset'); }
        const price = card.querySelector('[data-cf-card-price]'); if (price) price.textContent = variant.price;
      });
      content.replaceChildren(); const list = document.createElement('ul'); list.className = 'cf-browse-grid'; list.setAttribute('role', 'list'); cards.slice(0, 12).forEach(card => list.append(document.importNode(card, true))); content.append(list);
      if (!cards.length) content.textContent = text('no_ready');
    } catch { content.textContent = text('retry'); }
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-cf-ready-open]'); if (opener) { event.preventDefault(); openReady(opener); }
    if (event.target.closest('[data-cf-ready-close]')) { document.getElementById('CFReadyPieces')?.close(); drawerOpener?.focus(); }
  });

  let checkoutPending = false;
  let permittedForm = null;
  const alertCheckout = (button, message, line, cartItem) => {
    let alert = button.form?.querySelector('[data-cf-checkout-alert]') || button.parentElement.querySelector('[data-cf-checkout-alert]');
    if (!alert) { alert = document.createElement('div'); alert.dataset.cfCheckoutAlert = ''; alert.className = 'cf-checkout-alert'; alert.setAttribute('role', 'alert'); button.before(alert); }
    alert.replaceChildren(document.createTextNode(message));
    if (line?.dataset.cfMadeAllowed === 'true' && Number(line.dataset.cfStock) <= 0) {
      const action = document.createElement('button'); action.type = 'button'; action.className = 'cf-browse-more'; action.textContent = text('switch_made');
      action.addEventListener('click', async () => { action.disabled = true; try { await cartChange(cartItem.key, cartItem.quantity, publicProperties(cartItem.properties, 'made', line.dataset.cfMaking, line.dataset.cfDispatch, '')); location.assign(config.cartUrl); } catch { action.disabled = false; alert.prepend(document.createTextNode(text('retry'))); } }); alert.append(action);
    }
    const link = document.createElement('a'); link.href = config.cartUrl; link.textContent = text('review_bag'); alert.append(document.createTextNode(' '), link);
    alert.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };
  const prepareCheckout = async (button) => {
    const intendedQuantities = new Map();
    const intendedVariants = new Map();
    button.form?.querySelectorAll('.quantity__input').forEach(input => {
      const line = input.closest('tr')?.querySelector('[data-cf-cart-line]');
      if (line) { intendedQuantities.set(line.dataset.cfKey, Number(input.value)); intendedVariants.set(line.dataset.cfVariant, intendedVariants.has(line.dataset.cfVariant) ? null : Number(input.value)); }
    });
    const wantedQuantity = line => intendedQuantities.get(line.dataset.cfKey) ?? intendedVariants.get(line.dataset.cfVariant) ?? Number(line.dataset.cfQuantity);
    const snapshotUrl = new URL(config.cartUrl, location.origin); snapshotUrl.searchParams.set('section_id', 'cutfound-cart-availability');
    const [cart, response] = await Promise.all([fetch(`${rootPath}cart.js`).then(jsonResponse), fetch(snapshotUrl)]);
    if (!response.ok) throw new Error(text('retry'));
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const lines = [...html.querySelectorAll('[data-cf-cart-line]')]; if (lines.length !== cart.items.length) throw new Error(text('retry'));
    const readyQuantities = new Map();
    for (const line of lines) if (line.dataset.cfState === 'ready' && line.dataset.cfTracked === 'true') readyQuantities.set(line.dataset.cfVariant, (readyQuantities.get(line.dataset.cfVariant) || 0) + wantedQuantity(line));
    for (const line of lines) {
      const item = cart.items.find(item => item.key === line.dataset.cfKey);
      if (!item) throw new Error(text('retry'));
      const invalidReady = line.dataset.cfState === 'ready' && line.dataset.cfTracked === 'true' && (readyQuantities.get(line.dataset.cfVariant) || 0) > Number(line.dataset.cfStock);
      if (invalidReady || !Number.isSafeInteger(wantedQuantity(line)) || wantedQuantity(line) < 1 || line.dataset.cfCurrentState === 'unavailable') { alertCheckout(button, text('stock_changed'), line, item); return false; }
    }
    if (button.form && !button.form.reportValidity()) return false;
    const mixed = lines.some(line => line.dataset.cfState === 'ready') && lines.some(line => line.dataset.cfState === 'made');
    const mixedMessage = mixed ? text(config.mixed === 'separate' ? 'checkout_mixed_separate' : config.mixed === 'request' ? 'checkout_mixed_request' : 'checkout_mixed_together') : '';
    let updated = cart;
    for (const line of lines) {
      const item = updated.items.find(item => item.key === line.dataset.cfKey); if (!item) continue;
      const properties = publicProperties(item.properties, line.dataset.cfState, line.dataset.cfMaking, line.dataset.cfDispatch, mixedMessage);
      if (wantedQuantity(line) !== item.quantity || JSON.stringify(properties) !== JSON.stringify(item.properties)) updated = await cartChange(item.key, wantedQuantity(line), properties);
    }
    return true;
  };
  const checkout = async (button) => {
    if (checkoutPending || button.disabled) return;
    checkoutPending = true; button.setAttribute('aria-busy', 'true');
    try { if (await prepareCheckout(button)) { permittedForm = button.form; if (button.form) { button.form.querySelectorAll('[name="updates[]"]').forEach(input => { input.disabled = true; }); button.form.requestSubmit(button); } else location.assign(`${rootPath}checkout`); } }
    catch { alertCheckout(button, text('retry')); }
    finally { checkoutPending = false; button.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!button || (permittedForm && permittedForm === button.form)) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout(button);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    if (permittedForm === event.target) { permittedForm = null; return; }
    event.preventDefault(); event.stopImmediatePropagation(); checkout(event.submitter);
  }, true);

  window.CFAvailability = { beforeAdd, text, config };
  customElements.define('cf-availability-browse', AvailabilityBrowse);
  customElements.define('cf-product-availability', ProductAvailability);
})();













